<template>
  <div class="invite-by-email-container">
    <label v-html="$t('lent.send.email')"></label>
    <div class="invite-link-inner">
      <div class="invite-link-input-container">
        <multiple-emails-input v-model="emails" />
        <a-button :disabled="!sendEnabled" @click="send" type="primary">{{$t('send')}}</a-button>
      </div>
      <a @click="previewEmail" class="preview-link">{{ $t('email.preview') }}</a>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { Modal } from 'ant-design-vue';
import MultipleEmailsInput from '@/components/common/MultipleEmailsInput.vue';
import { SEND_INVITATION_EMAIL } from '@/store/referrals/actionTypes';
import {
  SHOW_DEFAULT_ERROR_NOTIFICATION,
  SHOW_NOTIFICATION,
} from '@/store/notification/actionTypes';
import EmailPreview from './EmailPreview.vue';

export default {
  components: {
    MultipleEmailsInput,
  },
  data() {
    return {
      emails: [],
    };
  },
  computed: {
    sendEnabled() {
      return !!this.emails.length;
    },
  },
  methods: {
    ...mapActions({
      sendInvitationMail: SEND_INVITATION_EMAIL,
      showErrorNotification: SHOW_DEFAULT_ERROR_NOTIFICATION,
      showNotification: SHOW_NOTIFICATION,
    }),
    async send() {
      try {
        await this.sendInvitationMail(this.emails);
        this.showNotification({
          type: 'success',
          message: this.$t('email.sent'),
        });
      } catch {
        this.showErrorNotification();
      }
    },
    previewEmail(e) {
      e.preventDefault();

      Modal.info({
        title: this.$t('email.preview'),
        content: (h) => h(EmailPreview),
        width: 600,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/metrics.scss';

.invite-by-email-container {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: baseline;
}

.invite-link-input-container {
  display: flex;
  align-items: flex-start;
  margin-bottom: $tiny;
  margin-top: $tiny;
}

.ant-input,
.vue-tags-input {
  width: 100% !important;
  max-width: 100% !important;
}

.ant-btn {
  margin: 0;
  margin-left: $tiny;
}

.preview-link {
  align-self: flex-start;
}

.emails-input {
  width: 100%;
}

.invite-link-inner {
  flex: 1;
}

label {
  flex: 1;
}
</style>
